export class ProdutoPacoteModel {
  id?: number;
  tipoLancamentoId?: number;
  descricao?: string;
  margemLucro?: number;
  tipoProduto?: string;
  valorPadrao?: number;
  valorMinimo?: number;
  quantidade?: number;
  market?: boolean;
  cfcCnpj?: string;
  produtoItem?: ProdutoItem[];

  constructor(options: ProdutoPacoteModel = {}) {
    this.tipoLancamentoId = options.tipoLancamentoId || null;
    this.descricao = options.descricao || null;
    this.margemLucro = options.margemLucro || null;
    this.tipoProduto = options.tipoProduto || null;
    this.valorPadrao = options.valorPadrao || null;
    this.valorMinimo = options.valorMinimo || null;
    this.quantidade = options.quantidade || null;
    this.market = options.market || null;
    this.cfcCnpj = options.cfcCnpj || null;
    this.produtoItem = options.produtoItem || null;
    this.id = options.id || null;
  }
}

interface ProdutoItem {
  id?: number;
  produtoId?: number;
  itemId?: number;
  quantidade?: number;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  ativo?: boolean;
  produto?: Produto;
  item?: Item;
}
interface Produto {
  id?: number;
  tipoLancamentoId?: number;
  descricao?: string;
  margemLucro?: number;
  tipoProduto?: string;
  valorPadrao?: number;
  valorMinimo?: number;
  quantidade?: number;
  market?: boolean;
  cfcCnpj?: string;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  ativo?: boolean;
  tipoLancamento?: TipoLancamento;
}
interface TipoLancamento {
  id?: number;
  descricao?: string;
  tipo?: string;
  valorPadrao?: number;
  ativo?: boolean;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  grupoLancamentoId?: number;
  grupoLancamento?: GrupoLancamento;
}
interface GrupoLancamento {
  id?: number;
  descricao?: string;
  ativo?: boolean;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  sindauto?: boolean;
}

interface Item {
  id?: number;
  tipoCreditoId?: number;
  descricao?: string;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  ativo?: boolean;
  tipoCredito?: TipoCredito;
}

interface TipoCredito {
  id?: number;
  ativo?: boolean;
  descricao?: string;
  usuarioCadastro?: string;
  dataCadastro?: any;
}
